(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mealsplan-section"]) return;
  try {
    

$(document).ready(function(){
  $(".planvalue").on("click", function(e){
    e.preventDefault();
	var value = $(this).data('id');
    var color = $(this).data('color');
    color     = color.substring(1);
              
    sessionStorage.removeItem('goals');
    sessionStorage.removeItem('day');
    sessionStorage.clear();
              
    sessionStorage.setItem('color', color);
    sessionStorage.setItem('mealPlan', value);
              
    window.location = "/pages/meals-ask"+ '?plan='+value+'&code='+color;
  });
});


  } catch(e) { console.error(e); }
})();
})();
